export const paymentValidationSchema = {
    paymentMethod: {
        nameOnCard: (value: string) => {
            if (!value) return "Please enter the cardholder's name exactly as it appears on the card";
            return undefined;
        },
        cardNumber: (value: string) => {
            const clean = value.replace(/\s+/g, '');
            if (!clean) return "Please enter a valid card number";
            if (clean.length < 13 || clean.length > 19) return "The credit card number must be at least 13 or 19 characters long";
            return undefined;
        },
        expiryMonth: (value: string) => {
            if (!value) return "Please select expiration month";
            return undefined;
        },
        expiryYear: (value: string) => {
            if (!value) return "Please select expiration year";
            return undefined;
        },
        securityCode: (value: string) => {
            if (!value) return "Please enter security code";
            if (value.length < 3) return "Invalid security code";
            return undefined;
        }
    },
    billingAddress: {
        address: (value: string) => {
            if (!value) return "Please enter address";
            return undefined;
        },
        city: (value: string) => {
            if (!value) return "Please enter city";
            return undefined;
        },
        country: (value: string) => {
            if (!value) return "Please select country";
            return undefined;
        },
        state: (value: string) => {
            if (!value) return "Please select state";
            return undefined;
        },
        postalCode: (value: string) => {
            if (!value) return "Please enter postal code";
            return undefined;
        }
    }
};

export const validatePaymentField = (section: 'paymentMethod' | 'billingAddress', field: string, value: any) => {
    const sectionSchema = (paymentValidationSchema as any)[section];
    if (sectionSchema && sectionSchema[field]) {
        return sectionSchema[field](value);
    }
    return undefined;
};
